<template>
    <a class="text-no-decoration filter-item" :class="isMobile && 'mobile'" @click="toggleFilter">
        <div v-if="isMobile" class="d-flex flex-align-center item-content">
            <span>{{ label }}</span>
        </div>

        <span v-else>{{ label }}</span>
    </a>
</template>

<script>
    import CatalogFilterLink from './CatalogFilterLink.vue';

    export default {
        name: 'CatalogDeliveryReadyItem',
        extends: CatalogFilterLink,

        props: {
            isMobile: Boolean,
        },
    };
</script>
